/* Kenetik Evergreen LP — shared behavior (reveal, tabs, slide-out cart drawer). Guarded so duplicate loads init once. */
(function(){if(window.__kenetikLP)return;window.__kenetikLP=1;
  /* Let the section fill the theme content width. Does NOT touch the theme header/footer. */
  function unconstrain(){
    var lp=document.querySelector('.ken-lp');
    if(lp){
      var p=lp.parentNode;
      while(p&&p!==document.body){
        if(p.classList&&(p.classList.contains('page-width')||p.classList.contains('page-width--narrow')||p.classList.contains('rte'))){
          p.style.maxWidth='none';p.style.paddingLeft='0';p.style.paddingRight='0';p.style.width='100%';}
        p=p.parentNode;
      }
    }
  }
  /* Reparent the sticky CTA to <body> so an ancestor transform can't trap its fixed positioning */
  function reparent(){
    var el=document.getElementById('ken-lp-sticky');
    if(el&&el.parentNode!==document.body){document.body.appendChild(el);}
  }
  /* Scroll reveal with a hard failsafe so content is never stuck hidden */
  function reveal(){
    var els=[].slice.call(document.querySelectorAll('.ken-lp-reveal'));
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
    setTimeout(function(){els.forEach(function(e){e.classList.add('is-in');});},1500);
  }
    function initTabs(){document.querySelectorAll('.ken-lp-tabs').forEach(function(tl){var tabs=tl.querySelectorAll('.ken-lp-tab');var wall=tl.parentNode;tabs.forEach(function(t){t.addEventListener('click',function(){tabs.forEach(function(x){x.setAttribute('aria-selected','false');});t.setAttribute('aria-selected','true');var n=t.getAttribute('data-tab');wall.querySelectorAll('.ken-lp-tabpanel').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===n);});});});});}
    /* Gruns-style slide-out cart drawer: AJAX add (subscription attached) -> drawer slides in. XHR (not fetch) dodges theme analytics that wrap window.fetch. */
  function cartDrawer(){
    var drawer=document.getElementById('ken-lp-cart');
    var bubble=document.getElementById('ken-lp-cart-bubble');
    var root=document.querySelector('.ken-lp')||document.body;
    if(!drawer) return;
    [drawer,bubble].forEach(function(el){if(el&&el.parentNode!==document.body){document.body.appendChild(el);}});
    var q=function(s){return drawer.querySelector(s);};
    function money(c){return '$'+(Math.round(c)/100).toFixed(2);}
    function xhr(m,u,b,cb){var x=new XMLHttpRequest();x.open(m,u,true);if(b)x.setRequestHeader('Content-Type','application/json');x.onload=function(){var d=null;try{d=JSON.parse(x.responseText);}catch(e){}cb(d,x.status);};x.onerror=function(){cb(null,0);};x.send(b?JSON.stringify(b):null);}
    function open(){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';var c=q('.ken-lp-cart__x');if(c)c.focus();}
    function close(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';}
    function render(cart){
      var box=q('[data-cart-items]'),empty=q('[data-cart-empty]'),ship=q('[data-cart-ship]'),co=q('[data-cart-checkout]');
      var n=(cart&&cart.item_count)||0;
      q('[data-cart-subtotal]').textContent=money((cart&&cart.total_price)||0);
      if(bubble){bubble.querySelector('[data-cart-count]').textContent=n;bubble.hidden=(n===0);}
      if(!cart||n===0){box.innerHTML='';empty.hidden=false;co.setAttribute('aria-disabled','true');ship.className='ken-lp-cart__ship';return;}
      empty.hidden=true;co.removeAttribute('aria-disabled');
      var saved=0;
      box.innerHTML=cart.items.map(function(it){
        var sp=(it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan)?it.selling_plan_allocation.selling_plan.name:'One-time purchase';
        if(it.original_line_price>it.final_line_price){saved+=(it.original_line_price-it.final_line_price);}
        var img=it.image||(it.featured_image&&it.featured_image.url)||'';
        return '<div class="ken-lp-cart__item" data-key="'+it.key+'">'+
          '<img class="ken-lp-cart__img" src="'+img+'" alt="" loading="lazy">'+
          '<div class="ken-lp-cart__meta"><div class="ken-lp-cart__name">'+it.product_title+'</div>'+
          '<div class="ken-lp-cart__plan">'+sp+(it.variant_title?(' \u00b7 '+it.variant_title):'')+'</div>'+
          '<div class="ken-lp-cart__qty"><button type="button" data-dec aria-label="Decrease quantity">\u2212</button>'+
          '<span>'+it.quantity+'</span><button type="button" data-inc aria-label="Increase quantity">+</button></div>'+
          '<button type="button" class="ken-lp-cart__rm" data-rm>Remove</button></div>'+
          '<div class="ken-lp-cart__price">'+money(it.final_line_price)+'</div></div>';
      }).join('');
      if(saved>0){ship.innerHTML='You\u2019re saving '+money(saved)+' with Subscribe &amp; Save';ship.className='ken-lp-cart__ship show';}else{ship.className='ken-lp-cart__ship';}
    }
    function refresh(cb){xhr('GET','/cart.js?t='+Date.now(),null,function(c){render(c);if(cb)cb(c);});}
    function addForm(form){
      var g=function(n){var el=form.querySelector('[name="'+n+'"]');return el?el.value:'';};
      var item={id:Number(g('id')),quantity:parseInt(g('quantity')||'1',10)||1};
      var pl=g('selling_plan');if(pl)item.selling_plan=Number(pl);
      var btn=form.querySelector('[type=submit]');var label=btn?btn.textContent:'';
      if(btn){btn.textContent='Adding\u2026';btn.disabled=true;}
      xhr('POST','/cart/add.js',{items:[item]},function(d,st){
        if(btn){btn.textContent=label;btn.disabled=false;}
        if(st>=200&&st<300){refresh(open);}else{form.submit();}
      });
    }
    document.addEventListener('submit',function(e){var f=e.target&&e.target.closest&&e.target.closest('.ken-lp-opt__form');if(f){e.preventDefault();addForm(f);}});
    drawer.addEventListener('click',function(e){
      var t=e.target;
      if(t.closest('[data-cart-close]')){close();return;}
      var it=t.closest('.ken-lp-cart__item');if(!it)return;
      var key=it.getAttribute('data-key');var cur=parseInt(it.querySelector('.ken-lp-cart__qty span').textContent,10)||1;
      var nq=null;
      if(t.closest('[data-rm]'))nq=0;else if(t.closest('[data-inc]'))nq=cur+1;else if(t.closest('[data-dec]'))nq=Math.max(0,cur-1);
      if(nq!==null)xhr('POST','/cart/change.js',{id:key,quantity:nq},render);
    });
    if(bubble)bubble.addEventListener('click',open);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'||e.keyCode===27)close();});
    document.addEventListener('click',function(e){var a=e.target&&e.target.closest&&e.target.closest('a[href^="#ken-lp"]');if(a){var t=document.getElementById(a.getAttribute('href').slice(1));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}}});
    refresh();
  }
  function init(){unconstrain();reparent();reveal();initTabs();cartDrawer();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  window.addEventListener('load',unconstrain);
})();
